// extracted by mini-css-extract-plugin
export default {"wrap":"MainLayout_wrap__26uzG"};